import React, { FC } from 'react'

import {
  Edit,
  Labeled,
  SimpleForm,
  TextInput,
} from 'react-admin'

import { PageTitle, SaveOnlyToolbar } from 'shared/react-admin';
import { ServicePlansTable } from './ServicePlansTable'

type ServiceEditProps = {
  children?: React.ReactElement
  editLayoutWrapper?: {
    component: any
    props: { [key: string]: any }
  }
  id?: string
  history?: any
}

export const ServiceEdit: FC<ServiceEditProps> = ({ children, editLayoutWrapper = { component: null, props: null } }) => {
  // const validateName = [
  //   (value) => (value.trim().split(' ').length <= 1 ? 'must be at least 2 words (First Last)' : undefined),
  // ];

  const renderForm = () => (
    <SimpleForm variant="outlined" redirect="edit" toolbar={<SaveOnlyToolbar />}>
      {/* <TextInput disabled label="Id" source="id" /> */}
      {/* <TextInput source="name" validate={validateName} /> */}
      <TextInput source="name" />
      {/* <TextInput source="email" validate={email()} /> */}
      <Labeled fullWidth label="StripePlans">
        <ServicePlansTable />
      </Labeled>
      {/* <Button label="Change Password" /> */}

      {children}
    </SimpleForm>
  )

  const { component: WrapperComponent, props: wrapperProps } = editLayoutWrapper

  return (
    <Edit title={<PageTitle resource="Service" source="name" />}>
      {!!WrapperComponent ? <WrapperComponent {...wrapperProps}>{renderForm()}</WrapperComponent> : <>{renderForm()}</>}
    </Edit>
  )
}
